import { useEffect } from 'react';
import BraintreeService from '../../business/processors/braintree/BraintreeService';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
var Braintree = function Braintree(props) {
  var callback = props.callback,
    dataCollectorCallback = props.dataCollectorCallback;
  var dispatch = useDispatch();
  var config = useAppSelector(configSelector);
  var _ref = config.appConstants,
    braintreeToken = _ref.braintreeToken;
  useEffect(function () {
    new BraintreeService({
      authorization: braintreeToken,
      callback: callback,
      dataCollectorCallback: dataCollectorCallback,
      dispatch: dispatch
    });
  }, [braintreeToken]);
  return null;
};
export default Braintree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/braintree/Braintree.js
// module id = 4581
// module chunks = 11